import { createAsyncThunk } from '@reduxjs/toolkit';

import { ISubmission } from '.';
import { APIDataProvider, TApiResponse, AdminApiPaths } from '../../api';
import { IQuestion } from '../QuestionSlice';

export interface IAdminGetSubmissions {
  limit: number;
  offset: number;
  userId: string;
}
export interface IAdminGetSubmissionQuestion {
  submissionId: string;
  questionId: string;
}

const apiDataProvider = new APIDataProvider();

const adminGetSubmissionListModule = async (data: IAdminGetSubmissions) => {
  const path = `${AdminApiPaths.submissions}/quizHistory/${data.userId}?userId=${data.userId}&limit=${data.limit}&offset=${data.offset}`;

  const response = await apiDataProvider.get<
    TApiResponse<{
      limit: number;
      offset: number;
      totalDocs: number;
      docs: Array<ISubmission>;
    }>
  >(path);

  return response.data;
};

export const adminGetSubmissionById = createAsyncThunk(
  'admin/submissions/id',
  async (id: string) => {
    const response = await apiDataProvider.get<TApiResponse<ISubmission>>(
      `${AdminApiPaths.submissions}/${id}`
    );

    return response.data;
  }
);

export const adminGetSubmissionQuestion = createAsyncThunk(
  'admin/submissions/question/id',
  async (data: IAdminGetSubmissionQuestion) => {
    const response = await apiDataProvider.get<TApiResponse<IQuestion>>(
      `${AdminApiPaths.submissions}/question/${data.questionId}?questionId=${data.questionId}&submissionId=${data.submissionId}`
    );

    return response.data;
  }
);

export const adminGetSubmissionList = createAsyncThunk(
  'admin/submissions/list',
  adminGetSubmissionListModule
);

export const adminLoadMoreSubmissionList = createAsyncThunk(
  'admin/submissions/loadMore',
  adminGetSubmissionListModule
);
